const constants = {
  PROFILE_URL: '/accounts/api/profile',
  ENVIRONMENTS_URL: orgId => `/accounts/api/organizations/${orgId}/environments`,
  LOGOUT_URL: '/accounts/api/logout',
  // SPA_URL: '/ui-shell', // <- Mounts SPA at a test path e.g. at https://devx.anypoint.mulesoft.com/ui-shell
  SPA_URL: '',          // <- Mounts SPA at root e.g. at https://devx.anypoint.mulesoft.com/
};

export default constants;
